module.exports = __webpack_public_path__ + "assets/img/mask-bg2.b1901873.png";